<div class="problem-areas">
  <h3>{{ 'CLIMATE_DEVIATIONS_BY_REGIONS' | translate }}</h3>
  <div class="grid mb-4 ml-1">
    @for (region of allRegionsLevel2; track region.id) {
      <div class="col-12 md:col-6 lg:col-6">
        <div class="area-link flex align-items-center gap-2"
             [class.has-problems]="getProblemCount(region) > 0"
             (click)="onRegionClick(region)">
          <span class="problem-badge" [class.no-problems]="getProblemCount(region) === 0">{{ getProblemCount(region) }}</span>
          <span class="region-name">{{ region | serverTranslate: 'names' }}</span>
        </div>
      </div>

    }
  </div>

  <div class="statistics">
    <p>{{ 'totalRegions' | translate:{count: totalRegions} }}</p>
    <p>{{ 'totalArea' | translate:{count: totalArea} }}</p>
    <p>{{ 'В процентах от площади РУз: 100%' | translate: {country: (environment.country | translate)} }}</p>
  </div>
</div>

<!-- Problem Crops Modal -->
<p-dialog
  [(visible)]="showModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '700px'}"
  [header]="selectedRegion ? (selectedRegion | serverTranslate: 'names') + ' - ' + ('Problem Crops' | translate) : ''"
  styleClass="problem-crops-modal">

  <app-data-table
    [columns]="tableColumns"
    [data]="selectedRegionCrops"
    [config]="tableConfig"
    [totalRecords]="selectedRegionCrops.length">
  </app-data-table>

  <ng-template pTemplate="footer">
    <div class="modal-footer-buttons">
      <app-secondary-button
        [title]="'Close' | translate"
        (action)="closeModal()">
      </app-secondary-button>
      <app-primary-button
        [title]="'Export' | translate"
        icon="pi pi-download"
        (action)="exportData()">
      </app-primary-button>
    </div>
  </ng-template>
</p-dialog>
